import { Component, EventEmitter, Input, Output, OnInit, OnChanges } from '@angular/core';

export interface CookieItem {
  name: string;
  description: string;
}

export interface CookieCategory {
  title: string;
  cookies: CookieItem[];
  expanded?: boolean;
}

@Component({
  selector: 'app-cookie-details-dialog',
  templateUrl: './cookie-details-dialog.component.html',
})
export class CookieDetailsDialogComponent implements OnInit, OnChanges {

  @Input() visible: boolean;
  @Input() msgCookies: string;
  @Input() linkCookies: string;
  @Output() accept = new EventEmitter();
  @Output() closeDialog = new EventEmitter();

  title: string;
  acceptBtnMsg: string;
  pdfLinkMsg: string;
  categories: CookieCategory[] = [];

  ngOnInit(): void {
    this.buildContent();
  }

  ngOnChanges(): void {
    this.buildContent();
  }

  buildContent(): void {
    if (localStorage.getItem('s3brazilwebportalfe_locale_id') == 'en') {
      this.title = 'Welcome to S3! Pay attention to our cookie usage policy.';
      this.acceptBtnMsg = 'Accept and continue';
      this.pdfLinkMsg = 'View the full Cookies Policy (PDF)';
      this.categories = [
        {
          title: 'Develop and improve services',
          cookies: [
            {
              name: 'ApplicationGatewayAffinity',
              description: 'This cookie is used to maintain the affinity of the user\'s session, ensuring that user requests within a session are sent to the same server in order to provide a consistent interaction with the web application.',
            },
            {
              name: 'x-ms-cpim-csrf',
              description: 'This cookie is used to prevent cross-site request forgery (CSRF) attacks, ensuring that each customer interaction with the server is unique and secure.',
            },
            {
              name: 'ApplicationGatewayAffinityCORS',
              description: 'This cookie is used in conjunction with load balancing to ensure that client requests are directed to the same server throughout the browsing session, improving the user experience by promoting the effective use of resources. Specifically, the CORS (Cross-Origin Resource Sharing) version allows the handling of requests between different domains.',
            },
          ],
        },
        {
          title: 'Necessary technological information',
          cookies: [
            {
              name: 'x-ms-cpim-trans',
              description: 'This cookie is used by Microsoft Azure AD B2C to store information related to user authentication transactions across different domains during a login process.',
            },
            {
              name: 'x-ms-cpim-cache',
              description: 'This cookie is used by Microsoft Azure AD B2C to keep the SSO session active.',
            },
            {
              name: 'nlbi_3041847',
              description: 'This cookie is associated with Incapsula\'s DDoS Protection and Web Application Firewall. It is used to ensure that a client\'s requests are sent to the same origin server.',
            },
            {
              name: 'incap_ses_1689_3041847',
              description: 'Incapsula DDoS Protection and Web Application Firewall: Cookie to link HTTP requests to a given session (also known as a visit). When you reopen your browser and access the same website, this is recorded as different visits. To maintain existing sessions (i.e., the session cookie).',
            },
          ],
        },
        {
          title: 'Using geolocation data',
          cookies: [
            {
              name: 'x-ms-cpim-geo',
              description: 'This cookie is set to identify the user\'s geographic location in order to improve the user experience and provide localized content.',
            },
          ],
        },
        {
          title: 'Storing and/or accessing information on a device',
          cookies: [
            {
              name: 'visid_incap_3041847',
              description: 'Incapsula DDoS Protection and Web Application Firewall: cookie to associate certain sessions with a specific visitor (visitor representing a specific computer). For the purpose of identifying customers who have already visited Incapsula.',
            },
          ],
        },
      ];
    } else {
      this.title = 'Bem vindo ao S3! Fique atento à nossa política de utilização de cookies.';
      this.acceptBtnMsg = 'Aceitar e continuar';
      this.pdfLinkMsg = 'Ver a Política de Cookies completa (PDF)';
      this.categories = [
        {
          title: 'Desenvolver e melhorar serviços',
          cookies: [
            {
              name: 'ApplicationGatewayAffinity',
              description: 'Este cookie é utilizado para manter a afinidade da sessão do usuário, garantindo que as solicitações do usuário dentro de uma sessão sejam enviadas ao mesmo servidor, a fim de proporcionar uma interação consistente com a aplicação web.',
            },
            {
              name: 'x-ms-cpim-csrf',
              description: 'Este cookie é utilizado para prevenir ataques de falsificação de solicitação entre sites (CSRF), garantindo que cada interação do cliente com o servidor seja única e segura.',
            },
            {
              name: 'ApplicationGatewayAffinityCORS',
              description: 'Este cookie é utilizado em conjunto com o balanceamento de carga para garantir que as solicitações dos clientes sejam direcionadas ao mesmo servidor durante toda a sessão de navegação, melhorando a experiência do usuário ao promover o uso eficaz dos recursos. Especificamente, a versão CORS (Cross-Origin Resource Sharing) permite o tratamento de solicitações entre diferentes domínios.',
            },
          ],
        },
        {
          title: 'Informações tecnológicas necessárias',
          cookies: [
            {
              name: 'x-ms-cpim-trans',
              description: 'Este cookie é utilizado pelo Microsoft Azure AD B2C para armazenar informações relacionadas às transações de autenticação do usuário em diferentes domínios durante um processo de login.',
            },
            {
              name: 'x-ms-cpim-cache',
              description: 'Este cookie é utilizado pelo Microsoft Azure AD B2C para manter a sessão de SSO ativa.',
            },
            {
              name: 'nlbi_3041847',
              description: 'Este cookie está associado à Proteção contra DDoS e ao Firewall de Aplicações Web da Incapsula. É utilizado para garantir que as solicitações de um cliente sejam enviadas ao mesmo servidor de origem.',
            },
            {
              name: 'incap_ses_1689_3041847',
              description: 'Proteção contra DDoS e Firewall de Aplicações Web da Incapsula: cookie para vincular solicitações HTTP a uma determinada sessão (também conhecida como visita). Ao reabrir o navegador e acessar o mesmo site, isso é registrado como visitas diferentes. Para manter as sessões existentes (ou seja, o cookie de sessão).',
            },
          ],
        },
        {
          title: 'Utilizar dados de geolocalização',
          cookies: [
            {
              name: 'x-ms-cpim-geo',
              description: 'Este cookie é definido para identificar a localização geográfica do usuário, a fim de melhorar a experiência do usuário e fornecer conteúdo localizado.',
            },
          ],
        },
        {
          title: 'Armazenar e/ou aceder informações num dispositivo',
          cookies: [
            {
              name: 'visid_incap_3041847',
              description: 'Proteção contra DDoS e Firewall de Aplicações Web da Incapsula: cookie para associar determinadas sessões a um visitante específico (visitante que representa um computador específico). Com o objetivo de identificar clientes que já visitaram a Incapsula.',
            },
          ],
        },
      ];
    }
    this.categories.forEach(category => category.expanded = false);
  }

  toggleCategory(category: CookieCategory): void {
    category.expanded = !category.expanded;
  }

  onAccept(): void {
    this.accept.emit();
  }

  onHide(): void {
    this.closeDialog.emit();
  }
}
